import styles from './ModalComponent.module.scss';
import {Component, cloneElement} from "react";
import type { ReactElement } from "react";
import CancelIcon from "@material-ui/icons/Cancel";

/**
 * Props que ModalComponent inyecta en su hijo con cloneElement.
 *
 * Cualquier componente que se monte dentro de una modal las recibe, las use o
 * no. @see ModalComponent.render
 */
export interface ModalChildProps {
    handleClose?: () => void;
}

export interface ModalComponentProps {
    /** El hijo unico de la modal. Recibe handleClose inyectado. */
    children: ReactElement;
    /** Falta en la disclaimer card, que se cierra sola. */
    closeHandler?: () => void;
    customClass?: string;
    height?: string;
    position?: string;
    autoHeight?: boolean;
    hideCloseIcon?: boolean;
    modal?: boolean;
}

class ModalComponent extends Component<ModalComponentProps> {

    constructor(props: ModalComponentProps) {
        super(props);
        this.close = this.close.bind(this);
    }

    close(): void {
        this.props.closeHandler!();
    }

    render() {
        const content = <div
            className={this.props.customClass ?
                this.props.customClass + ' ' + styles.modalInside : styles.modalInside}
            style={{
                maxHeight: this.props.height,
                bottom: this.props.position === 'top' ? '40px' : 0,
                top: this.props.position === 'top' ? 'auto' : 0,
                height: this.props.autoHeight ? 'auto' : this.props.height,
            }}>
            {cloneElement(this.props.children, { handleClose: this.close })}
            {
                this.props.hideCloseIcon ?
                    null
                    :
                    <div className={styles.cancelIcon + ' cancel-icon'}>
                        <CancelIcon color="action" onClick={this.close}/>
                    </div>
            }
        </div>

        return (
            this.props.modal ?
                <div className={styles.modal}>
                    {content}
                </div>
                :
                <div style={{
                    maxHeight: this.props.height,
                }}>
                    {content}
                </div>
        )
    }

}

export default ModalComponent
